import React from "react";

import Modal from "@src/sharedComponents/Modal/Modal";
import Skeleton from "@src/sharedComponents/Skeleton/Skeleton";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "@src/sharedComponents/Modal/SimpleModalWithCenteredButtons/SimpleModalWithCenteredButtons.module.css";

interface Props {
  title: string;
  onClose: () => void;
  text?: string;
  isOpen?: boolean;
}

const LoadingModal: React.FC<Props> = ({
  title,
  onClose,
  text,
  isOpen = true,
}): JSX.Element => {
  return (
    <Modal
      className={styles.modal}
      closeModal={onClose}
      showCloseButton={true}
      isOpen={isOpen}
    >
      <Text variant="title2">{title}</Text>

      <Text className={styles.bodyText}>{text}</Text>
      <Skeleton
        width="100%"
        height={20}
        style={{ transform: "none", marginBottom: "24px" }}
      />

      <div className={styles.footer}>
        <Skeleton width={70} height={35} style={{ transform: "none" }} />

        <Skeleton width={70} height={35} style={{ transform: "none" }} />
      </div>
    </Modal>
  );
};

export default LoadingModal;
